import {
  Breakpoint,
  MediaType,
  type OptimizedSources,
} from '@farmersdog/corgi-x';

import CnetMobilePng from './cnet-mobile.png';
import CnetMobileWebp from './cnet-mobile.webp';
import CnetDesktopPng from './cnet-desktop.png';
import CnetDesktopWebp from './cnet-desktop.webp';
import GoodHousekeepingMobilePng from './good-housekeeping-mobile.png';
import GoodHousekeepingMobileWebp from './good-housekeeping-mobile.webp';
import GoodHousekeepingDesktopPng from './good-housekeeping-desktop.png';
import GoodHousekeepingDesktopWebp from './good-housekeeping-desktop.webp';
import GoogleMobilePng from './google-mobile.png';
import GoogleMobileWebp from './google-mobile.webp';
import GoogleDesktopPng from './google-desktop.png';
import GoogleDesktopWebp from './google-desktop.webp';
import NewYorkMagazineMobilePng from './new-york-magazine-mobile.png';
import NewYorkMagazineMobileWebp from './new-york-magazine-mobile.webp';
import NewYorkMagazineDesktopPng from './new-york-magazine-desktop.png';
import NewYorkMagazineDesktopWebp from './new-york-magazine-desktop.webp';
import PopularScienceMobilePng from './popular-science-mobile.png';
import PopularScienceMobileWebp from './popular-science-mobile.webp';
import PopularScienceDesktopPng from './popular-science-desktop.png';
import PopularScienceDesktopWebp from './popular-science-desktop.webp';

type PressBarItem =
  | 'popularScience'
  | 'goodHousekeeping'
  | 'google'
  | 'newYorkMagazine'
  | 'cnet';

const mobileBreakpoint = `(max-width: ${Breakpoint.MD - 1}px)`;
const desktopBreakpoint = `(min-width: ${Breakpoint.MD}px)`;

export const sources: Record<PressBarItem, OptimizedSources> = {
  popularScience: [
    {
      src: PopularScienceMobileWebp,
      type: MediaType.Webp,
      media: mobileBreakpoint,
    },
    {
      src: PopularScienceMobilePng,
      type: MediaType.Png,
      media: mobileBreakpoint,
    },
    {
      src: PopularScienceDesktopWebp,
      type: MediaType.Webp,
      media: desktopBreakpoint,
    },
    {
      src: PopularScienceDesktopPng,
      type: MediaType.Png,
      media: desktopBreakpoint,
    },
  ],
  goodHousekeeping: [
    {
      src: GoodHousekeepingMobileWebp,
      type: MediaType.Webp,
      media: mobileBreakpoint,
    },
    {
      src: GoodHousekeepingMobilePng,
      type: MediaType.Png,
      media: mobileBreakpoint,
    },
    {
      src: GoodHousekeepingDesktopWebp,
      type: MediaType.Webp,
      media: desktopBreakpoint,
    },
    {
      src: GoodHousekeepingDesktopPng,
      type: MediaType.Png,
      media: desktopBreakpoint,
    },
  ],
  google: [
    {
      src: GoogleMobileWebp,
      type: MediaType.Webp,
      media: mobileBreakpoint,
    },
    {
      src: GoogleMobilePng,
      type: MediaType.Png,
      media: mobileBreakpoint,
    },
    {
      src: GoogleDesktopWebp,
      type: MediaType.Webp,
      media: desktopBreakpoint,
    },
    {
      src: GoogleDesktopPng,
      type: MediaType.Png,
      media: desktopBreakpoint,
    },
  ],
  newYorkMagazine: [
    {
      src: NewYorkMagazineMobileWebp,
      type: MediaType.Webp,
      media: mobileBreakpoint,
    },
    {
      src: NewYorkMagazineMobilePng,
      type: MediaType.Png,
      media: mobileBreakpoint,
    },
    {
      src: NewYorkMagazineDesktopWebp,
      type: MediaType.Webp,
      media: desktopBreakpoint,
    },
    {
      src: NewYorkMagazineDesktopPng,
      type: MediaType.Png,
      media: desktopBreakpoint,
    },
  ],
  cnet: [
    {
      src: CnetMobileWebp,
      type: MediaType.Webp,
      media: mobileBreakpoint,
    },
    {
      src: CnetMobilePng,
      type: MediaType.Png,
      media: mobileBreakpoint,
    },
    {
      src: CnetDesktopWebp,
      type: MediaType.Webp,
      media: desktopBreakpoint,
    },
    {
      src: CnetDesktopPng,
      type: MediaType.Png,
      media: desktopBreakpoint,
    },
  ],
};
